import React from 'react';
import clsx from 'clsx';
import CircularProgress from '@material-ui/core/CircularProgress';
import Button from '@material-ui/core/Button';
import {withStyles} from "@material-ui/core";
import {Styles} from "../../../config/design/styles";
import PopupState, {bindPopover, bindTrigger} from "material-ui-popup-state";
import Box from "@material-ui/core/Box/Box";
import Typography from "@material-ui/core/Typography/Typography";
import {Translate} from "../../../config/Translate";
import DeleteRoundedIcon from "@material-ui/icons/DeleteRounded";
import Popover from "@material-ui/core/Popover/Popover";

class LoadingButton extends React.Component{
    state= {
        loading:false,
        success:false,
        copen:true
    };
    componentDidMount(){
        this.setState({
            loading:this.props.loading,
            success:this.props.success
        })
    }
    classes = this.props.classes;
    handleClick(e){
        this.props.onClick(e)
        this.setState({
            copen:false
        })

    }
    render(){
        let {copen} = this.state;
        let {
            children,type,variant,color,endIcon,
            onClick,size,loading,success,style,
            disabled,startIcon,styleForParent,
            icon,tooltip,className,yes_btn,btn_color,question
        } =this.props;
        let buttonClassName = clsx({
            [this.classes.buttonSuccess]: success,
        });
    return (

        <PopupState variant="popover" popupId="demo-popup-popover">
            {(popupState) => (
        <div style={styleForParent} className={this.classes.LoadingButtonWrapper}>
            <Button
                variant={variant}
                type={type}
                style={style}
                color={color}
                startIcon={startIcon}
                endIcon={endIcon}
                className={buttonClassName}
                disabled={disabled || loading}
                size={size}
                {...bindTrigger(popupState)}
            >
                {children}
            </Button>
            {
                !!copen &&
                <Popover
                    elevation={1}
                    {...bindPopover(popupState)}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'center',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                >
                    <Box p={1}>
                        <Typography>
                            {!!question ? question : Translate.areYouSure}
                            <Button
                                style={{color:!!color ? color: "#f44336",marginRight:5}}
                                startIcon={icon ? icon : <DeleteRoundedIcon/>}
                                onClick={(e) => this.handleClick(e)}
                            >
                                {!!yes_btn ? yes_btn : Translate.yes}
                            </Button>
                        </Typography>
                    </Box>
                </Popover>
            }

            {loading && <CircularProgress size={24} className={this.classes.buttonProgress} />}
        </div>
            )}
                </PopupState>
    );
}
}
export default withStyles(Styles)(LoadingButton);